import { create } from 'zustand';
import type { StreamingState, StreamEvent } from '../streaming/types';
import { streamEventReducer, initialStreamingState } from '../streaming';

interface StreamingStore extends StreamingState {
  // Actions
  processEvent: (event: StreamEvent) => void;
  startStreaming: (conversationId?: string) => void;
  resetStreaming: () => void;
}

export const useStreamingStore = create<StreamingStore>((set, get) => ({
  ...initialStreamingState,

  processEvent: (event) => {
    const currentState = get();
    const newState = streamEventReducer(currentState, event);
    set(newState);
  },

  startStreaming: (conversationId) => {
    set({
      ...initialStreamingState,
      status: 'connecting',
      conversationId: conversationId || null,
    });
  },

  resetStreaming: () => {
    set(initialStreamingState);
  },
}));
